import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import { App } from "./App";
import { AuthProvider } from "./auth";
import "./index.css";
import { swRegistrationPlan } from "./pwa/registerSw";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // refresh.js gorunurluk korumali yenileme deseni: sekme arka
      // plandayken tazeleme durur, odaklaninca hemen tekrar sorgular.
      refetchOnWindowFocus: true,
      refetchIntervalInBackground: false,
      retry: 1,
      staleTime: 30_000,
    },
  },
});

const basename = import.meta.env.BASE_URL.replace(/\/$/, "");

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("#root bulunamadi");

createRoot(rootEl).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter basename={basename}>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);

const swPlan = swRegistrationPlan(import.meta.env.BASE_URL, import.meta.env.PROD, "serviceWorker" in navigator);
if (swPlan) {
  navigator.serviceWorker.register(swPlan.url, { scope: swPlan.scope }).catch(() => {
    // sessizce yut — statik onbellek yoksa da uygulama calisir
  });
}
